module.exports = __webpack_public_path__ + "img/services5.f2e4deaf.jpg";